export default __webpack_public_path__ + "static/media/IMG_1832.2cb8c493.jpg";